export const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function slugify(value: string): string {
  return (
    value
      // Replace special characters
      .replace(/[\s~`!@#$%^&*()\-_+=[\]{}|\\;:"'<>,.?/]+/g, '-')
      // Remove continuous separators
      .replace(/-{2,}/g, '-')
      // Remove prefixing and trailing separators
      .replace(/^-+|-+$/g, '')
      // ensure it doesn't start with a number (like #123)
      .replace(/^(\d)/, '_$1')
      // lowercase
      .toLowerCase()
  );
}

export function removeAccents(string: string): string {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function splitAtLastSpace(str: string) {
  const lastSpaceIndex = str.lastIndexOf(' ');
  const firstPart = str.substring(0, lastSpaceIndex);
  const secondPart = str.substring(lastSpaceIndex + 1);

  return [firstPart, secondPart];
}
